export default "__VITE_ASSET__DlcL4NrX__"